import React from 'react';

const CircleDark = ({ ...props }) => {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <circle cx="6" cy="6" r="6" fill="#222222" />
        </svg>
    );
};

export default CircleDark;
